import React from 'react'
import { ReactComponent as Back } from './icons/back.svg'
import site from './assets/site.png'
import siteMobile from './assets/site-mobile.png'
import siteMobileLandscape from './assets/site-mobile-landscape.png'
import Footer from '../Footer'

function EversetCheckoutModal({ onClose }) {
  return (
    <div className="z-[1000] bg-[rgba(0,0,0,.9)] h-screen w-screen fixed top-0 left-0">
      <div className="w-full bg-[#242528] h-[50px] px-[20px] flex items-center text-white relative z-[10]">
        <button type="button" onClick={onClose}>
          <Back />
        </button>
        <div className="text-normal ml-[20px] truncate">Back to floor plan and package selection </div>
      </div>
      <div className="bg-[white] h-[calc(100vh-50px-30px)] w-full flex items-center">
        <img src={siteMobileLandscape} className="max-w-full w-full landscape:inline-block portrait:hidden lg:!hidden" alt="cart" />
        <img src={site} className="max-w-full w-full hidden lg:inline-block" alt="cart" />
        <img src={siteMobile} className="max-w-full w-full landscape:hidden lg:hidden" alt="cart" />
      </div>
      <Footer className='hidden lg:flex' disclaimer={false}/>
      {/* <iframe className="h-full border-none w-full" src="https://theeverset.com/cart" />
      < */}
    </div>
  )
}

export default EversetCheckoutModal
